import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

import { INFERENCE_STATUSES, InferenceStatus, UserPolices } from "constant";
import usePolicy from "hooks/usePolicy";

import IconButton from "components/buttons/IconButton/IconButton";
import InferenceAction from "components/InferenceAction/InferenceAction";
import InferenceStatusComponent from "components/InferenceStatusComponent/InferenceStatusComponent";
import ShowHideButton from "components/buttons/ShowHideButton/ShowHideButton";

import DragHandleDotsIcon from "assets/icons/drag-handle-dots.svg";
import TrashIcon from "assets/icons/trash.svg";
import EyeCloseGrayIcon from "assets/icons/eye-close-gray.svg";
import EyeOpenGrayIcon from "assets/icons/eye-open-gray.svg";
import MarkersFlagOffIcon from "assets/icons/markers-flag-off.svg";
import MarkersFlagOnIcon from "assets/icons/markers-flag.svg";

import styles from "./provider-manager-modal.module.scss";

const SortableItem = ({
  item,
  id,
  alias,
  onUpdateVisibilityProvidersMarkers,
  onUpdateVisibilityProvidersTiles,
  inferenceDurationTime,
  onDelete
}) => {
  const { hasPolicy } = usePolicy();

  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: item.id.toString() });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition
  };

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={styles["providers-table__body"]}
    >
      <div className={styles["drag-dots"]}>
        <img
          src={DragHandleDotsIcon}
          alt="drag-dots"
          {...attributes}
          {...listeners}
          style={{ cursor: "grab" }}
        />
        <ShowHideButton
          onClick={onUpdateVisibilityProvidersTiles(item)}
          isActive={item.isActiveTiles}
          enabledIcon={EyeOpenGrayIcon}
          disabledIcon={EyeCloseGrayIcon}
        />
        <ShowHideButton
          onClick={onUpdateVisibilityProvidersMarkers(item)}
          isActive={item.isActiveMarkers}
          enabledIcon={MarkersFlagOnIcon}
          disabledIcon={MarkersFlagOffIcon}
        />
      </div>
      <div className={styles["name"]}>{item.data.name}</div>
      <div className={styles["link"]}>{item.data.link}</div>
      {hasPolicy(UserPolices.PROJECT_PROVIDER_DELETE) && (
        <div>
          <IconButton
            onClick={onDelete(item.id)}
            icon={TrashIcon}
            alt="trash-icon"
            disabled={item.isDeleteProviderLoading}
            isLoading={item.isDeleteProviderLoading}
          />
        </div>
      )}
      <InferenceAction
        id={id}
        providerId={item.id}
        alias={alias}
        status={INFERENCE_STATUSES[item?.inference?.status]}
        isLoading={item.isInferenceStatusWaiting}
        disabled={item.isDeleteProviderLoading}
      />
      <div className={styles["name"]}>
        {inferenceDurationTime(item?.inference)}
      </div>
      <InferenceStatusComponent
        status={INFERENCE_STATUSES[item?.inference?.status]}
        completionPercentage={
          item?.inference?.status === InferenceStatus.PROCESSING
            ? item?.inference?.data?.completion_percentage
            : undefined
        }
      />
    </div>
  );
};

export default SortableItem;
